import { useNavigate } from "react-router-dom"

import Style from "./style"
import caution500 from "./asset/caution500.svg"
import DefaultButton from "shared/ui/DefaultButton"

const InternalServerError = () => {
    const navigate = useNavigate()

    return (
        <Style.WrapperDiv>
            <Style.CautionSvg src={caution500} />
            <Style.Title>죄송합니다.</Style.Title>
            <Style.ContentDiv>
                <p>서버와의 통신 중에 문제가 발생하였습니다.</p>
                <p>현재 서버가 점검 중일 수 있으니, 관리자에게 문의해 주세요.</p>
            </Style.ContentDiv>
            <Style.BtnDiv>
                <DefaultButton clickEvent={() => navigate("/")}>홈 으로 돌아가기</DefaultButton>
            </Style.BtnDiv>
        </Style.WrapperDiv>
    )
}

export default InternalServerError